import { useEvent } from '@anton.bobrov/react-hooks';
import { useRef } from 'react';
export function useParentHeight(ref) {
    var currentHeightRef = useRef(0);
    var save = useEvent(function () {
        var parent = ref.current;
        if (!parent) {
            return;
        }
        currentHeightRef.current = parent.getBoundingClientRect().height;
        parent.style.height = "".concat(currentHeightRef.current, "px");
    });
    var reset = useEvent(function () {
        var parent = ref.current;
        if (!parent) {
            return;
        }
        currentHeightRef.current = 0;
        parent.style.height = '';
    });
    var interpolate = useEvent(function (targetHeight, progress) {
        var parent = ref.current;
        if (!parent) {
            return;
        }
        var startHeight = currentHeightRef.current;
        var difference = targetHeight - startHeight;
        var height = startHeight + difference * progress;
        parent.style.height = "".concat(height, "px");
    });
    return { save: save, reset: reset, interpolate: interpolate };
}
//# sourceMappingURL=useParentHeight.js.map